import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { functionpermission } from './taxs-details.modal';
import { TDService } from './taxs/taxs.service';

@Component({
  selector: 'app-taxs-details',
  templateUrl: './taxs-details.component.html',
  styleUrls: ['./taxs-details.component.scss']
})
export class TaxsDetailsComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();

  TaskTab: string = "nav-tax";
  isViewRelationshipList: boolean = false;
  isViewTaskDetails: boolean = true;
  isViewTaskPercent: boolean = false;
  constructor(public global: GlobalComponent,public Taxservice:TDService) {
    this.global.checkforlogout();
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == '' || this.global.globalAgencyId == '00000000-0000-0000-0000-000000000000') {
      return;

    }
  }
fp:functionpermission=new functionpermission()

  ngOnInit(): void {
    this.getpermission()
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "TaxDetails");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.Taxservice.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fp = data;

      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}
 
  tabChanged(tab) {
    this.TaskTab = tab;
    if (this.TaskTab == 'nav-tax') {
      this.isViewTaskDetails = true;
      this.isViewRelationshipList = false;
      this.isViewTaskPercent = false;
    }
    else if (this.TaskTab == 'nav-relationship-list') {
      this.isViewRelationshipList = true;
      this.isViewTaskDetails = false;
      this.isViewTaskPercent = false;
    }
    else if (this.TaskTab == 'nav-taxpercent') {
      this.isViewTaskPercent = true;
      this.isViewRelationshipList = false;
      this.isViewTaskDetails = false;
    }
  }
}
